import type { EntryPoint, EntryPointComponent, PreloadFetchPolicy } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

// oxlint-disable-next-line eslint-plugin-import(extensions) -- Relay-generated .graphql.ts artifact; the `.graphql` suffix is required to resolve it
import parameters, {
	type HomeStarredListQuery,
} from './starred-list/__generated__/HomeStarredListQuery.graphql';
import type { RuntimeProps } from './starred-list/types';

type EntryPointParams = {
	cypherQuery: string;
	queryContext: string;
};

const fetchPolicy: PreloadFetchPolicy = 'store-or-network';

type StarredListEntryPointComponent = EntryPointComponent<
	{
		queryReference: HomeStarredListQuery;
	},
	{},
	RuntimeProps,
	{}
>;

export const starredListEntryPoint: EntryPoint<StarredListEntryPointComponent, EntryPointParams> =
	createEntryPoint({
		root: JSResourceForInteraction<StarredListEntryPointComponent>(() => import(/* webpackChunkName: "@atlassian/home-starred-entrypoint" */ "./starred-list/HomeStarredListQuery"), { moduleId: "86c115a4", moduleName: "HomeStarredListQuery", modulePath: "../platform/packages/townsquare/home-starred/src/starred-list/HomeStarredListQuery.tsx", priority: "interaction", moduleId: 'starredListEntryPoint' }),
		getPreloadProps: ({ cypherQuery, queryContext }: EntryPointParams) => ({
			queries: {
				queryReference: {
					parameters,
					variables: {
						cypherQuery,
						queryContext,
						first: 250,
					},
					options: {
						fetchPolicy,
					},
				},
			},
		}),
	});
